export default {
  init() {
    let submit = () => {
      let filter = $('#form-cpm-job-filters');
      $.ajax({
        url: filter.attr('action'),
        data: filter.serialize(),
        type: filter.attr('method'),
        success: function (data) {
          data = JSON.parse(data);
          $('#response').html(data.jobs);
          $('#counter-cpm-jobs').html(data.count);
          $('#pagination-cpm-jobs').html(data.paginate)
        },
      });
    };

    // When a filter or a sorter is clicked
    $('#form-cpm-job-filters input[type="checkbox"], #form-cpm-job-filters select').change(() => {
      submit();
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/jobs.js